import { render, staticRenderFns } from "./claimState.vue?vue&type=template&id=d08d46bc&scoped=true&"
import script from "./claimState.vue?vue&type=script&lang=js&"
export * from "./claimState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08d46bc",
  null
  
)

export default component.exports